/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Secure_TipInputs */

const en_pc_tut_secure_tip = /** @type {(inputs: Pc_Tut_Secure_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document Properties shows the encryption method, which password opened the file and each permission.`)
};

const zh_pc_tut_secure_tip = /** @type {(inputs: Pc_Tut_Secure_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「文档属性」会显示加密方式、使用了哪个密码打开以及每一项权限。`)
};

/**
* | output |
* | --- |
* | "Document Properties shows the encryption method, which password opened the file and each permission." |
*
* @param {Pc_Tut_Secure_TipInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_secure_tip = /** @type {((inputs?: Pc_Tut_Secure_TipInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Secure_TipInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_secure_tip(inputs)
	return zh_pc_tut_secure_tip(inputs)
});
export { pc_tut_secure_tip as "pc.tut.secure.tip" }